module.exports = __webpack_public_path__ + "assets/img/call.6dbea19e.svg";